<template>
  <v-card v-bind="$attrs">
    <v-card-title>
      <section-header icon="mdi mdi-human-greeting-variant">
        {{ $t('tenant.teams') }}
      </section-header>
    </v-card-title>
    <v-card-text class="body-1">
      {{ $t('tenant.teams_help') }}
    </v-card-text>
    <v-list>
      <v-skeleton-loader v-if="loading" type="list-item-two-line"></v-skeleton-loader>
      <v-slide-x-transition group>
        <template v-for="team in teams">
          <v-list-item :key="team.key">
            <v-list-item-content>
              <v-list-item-title :style="{color: $randomizeColorFromString(team.key)}" class="body-1 font-weight-bold">
                {{ team.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t('teams.types.' + team.type) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="flex-row" style="width: 88px;">
              <v-btn class="mt-n1" color="secondary" icon @click="handleOpenTeamEdit(team)">
                <v-icon>mdi mdi-pencil</v-icon>
              </v-btn>
              <v-btn class="mt-n1" color="error" icon @click="handleDeleteTeam(team)">
                <v-icon>mdi mdi-delete-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="`${team.key}_divider`" class="mx-3"></v-divider>
        </template>
      </v-slide-x-transition>
    </v-list>
    <v-card-actions :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : ''">
      <v-btn :block="$vuetify.breakpoint.xsOnly" :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
             :outlined="$vuetify.breakpoint.xsOnly"
             color="primary"
             text
             @click="handleCreateTeam">
        <v-icon left>add</v-icon>
        {{ $t('teams.create_team') }}
      </v-btn>
    </v-card-actions>

    <edit-team-dialog ref="editTeamDialog" @refresh="reloadTeams"/>

  </v-card>
</template>

<script>
import EditTeamDialog from "@/components/Tenant/EditTeamDialog";
import SectionHeader from "@/components/SectionHeader";
import teamApi from "@/api/team";

export default {
  name: "TenantTeams",
  components: {SectionHeader, EditTeamDialog},
  data() {
    return {
      teams: [],
      loading: false,
    }
  },
  methods: {
    async reloadTeams() {
      try {
        const response = await teamApi.getTeams();
        if (response) {
          this.teams = response;
        }
      } catch (e) {
        this.$handleApiError(e, this.$t('teams.errors.error_loading'));
      }
    },
    handleOpenTeamEdit(team) {
      this.$refs.editTeamDialog.open(team.key);
    },
    handleCreateTeam() {
      this.$refs.editTeamDialog.open();
    },
    async handleDeleteTeam(team) {
      const confirm = await this.$confirmDelete(this.$t('tenant.confirm_team_delete'), this.$t('tenant.confirm_team_delete_text'));
      if (!confirm) return;

      try {
        await teamApi.deleteTeam(team.key);
        this.$showSuccessNotification(this.$t('tenant.team_deleted_succesfully'));
        await this.reloadTeams();
      } catch (error) {
        this.$handleApiError(error, this.$t('errors.error_deleting_team'));
      }
    }
  },
  async mounted() {
    this.loading = true;
    await this.reloadTeams();
    this.loading = false;
  }
}
</script>

<style scoped>

</style>
